import { memo } from 'react';
import { Row, Col } from 'antd';
import { useNavigate, createSearchParams } from 'react-router-dom';
import { FeatureItem } from '../featureListData';
import classNames from 'classnames';
import { useUniversityContext } from '@/context';

export interface FeatureListProps {
  color: string;
  features: FeatureItem[];
}

export const FeatureList = memo(({ features, color }: FeatureListProps) => {
  const navigate = useNavigate();

  const university = useUniversityContext()?.university;
  const universityURL = university?.universityURL ?? '';

  return (
    <Row className="flex flex-fill flex-wrap w-full items-center justify-start">
      {(features ?? []).map((item) => {
        if (!item.visible) {
          return null;
        }
        const disabled = item.samadKey && !university?.samad?.[item.samadKey];
        return (
          <Col
            lg={6}
            span={8}
            key={Math.random()}
            style={{ filter: disabled ? 'grayscale(1)' : 'unset' }}
            className="!flex flex-col justify-center items-center cursor-pointer px-2 py-2 lg:!py-5 3xl:!py-8"
            onClick={() => disabled ? undefined : item?.target ?
              navigate({
                pathname: item.target,
                search: `?${createSearchParams(item.query)}`
              }) :
              item?.onClick
                ? item?.onClick(universityURL)
                : null
            }>
            <div
              className="flex flex-col center round-full pb-2.5"
              style={{
                width: 'max(3.2vw, 40px)',
                minHeight: '60px',
                maxHeight: '70px'
              }}>
              {typeof item.icon === 'string' ?
                <img
                  className="icon-xxl color-2e6"
                  src={`data:image/svg+xml;base64,${btoa(item.icon)}`}
                /> : item.icon}
            </div>
            <span
              style={{ color: item.enable ? color : '#979797' }}
              className={classNames('text-sm font-bold text-center', item.enable ? 'text-primary-dark' : 'text-disable')}>
              {item.text}
            </span>
          </Col>
        );
      })}
    </Row>
  );
});

export default FeatureList;
